export class ControlPanelSettingsEntry {

  constructor(public driver: boolean,
              public tachoTime: boolean,
              public service: boolean,
              public connections: boolean) {
  }

  public static defaultValues(isClientEmployee: boolean): ControlPanelSettingsEntry {
    return new ControlPanelSettingsEntry(
      isClientEmployee,
      isClientEmployee,
      false,
      false
    )
  }

}
